import { render, staticRenderFns } from "./project-group-set.vue?vue&type=template&id=67e4641e&scoped=true"
import script from "./project-group-set.vue?vue&type=script&lang=js"
export * from "./project-group-set.vue?vue&type=script&lang=js"
import style0 from "./project-group-set.vue?vue&type=style&index=0&id=67e4641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4641e",
  null
  
)

export default component.exports